import router from "@/router";
import { removeCookie } from "@/helpers/collections";

const state = {
  isUserLogged: false
};

const mutations = {
  // SET_TOKEN: (state, token) => {
  //   state.token = token;
  // },
  // SET_USER: (state, user) => {
  //   state.user = user
  // },
  SET_USER_LOGGED_STATUS: (state, status) => {
    state.isUserLogged = status;
  }
};

const actions = {
  setUserLoggedStatus: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_USER_LOGGED_STATUS", payload);
  },
  onLogoutUser: async ({ dispatch, commit, state }, payload) => {
    removeCookie();
    // dispatch("onHandleLogout") //delete token from backend
    await commit("ON_LOGOUT", payload);
    await commit("SET_USER_LOGGED_STATUS", false);
    await router.push({ path: "/" });
  }
  //onHandleLogout: async ({ dispatch, commit, state }, payload) => {
  // UserServices.LogOutUser()
  //   .then(response => {
  //   })
  //   .catch(error => { })
  //   .finally(async () => {
  //   })
  // }
};
const getters = {
  getUserInfo: state => state.user,
  getIsUserLogged: state => state.isUserLogged
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/Account.js